import React, { Component } from 'react';
import { observer } from 'mobx-react';

import AnchorLiveFeed from '../anchorComponents/AnchorLiveFeed/AnchorLiveFeed';
import GroupShowStore from '../../store/GroupShowStore';
import NNLiveLogo from '../../assets/NNLiveAds/ad-nnlive-mobile.png';
import '../../css/LiveBannerAnchor.css';


@observer
class LiveBanner extends Component {
  constructor(...args) {
    super(...args);

    const { user, extractIdFromSlug } = this.props;
    const { authenticated } = user;
    let existingSubscription = undefined;
    if (authenticated) {
      const { user: { account } } = user;
      const { anchorSubscriptions } = account || {};
      const checkId = extractIdFromSlug();
      existingSubscription = anchorSubscriptions?.find((sub) => sub.subCategory === checkId);
    }

    this.state = { isSubscribed: Boolean(existingSubscription) };
  }

  onClick = () => this.props.openContextualOverlay(true);

  bannerInfoAndCta = (className) => {
    const { nakedNewsLiveAnchorData: { image, promopic } } = this.props;
    const bannerImage = className === 'desktop' ? image : promopic;
    const { isSubscribed } = this.state;
    const url = !isSubscribed ? '/account/purchase?_anchor=241&_shortUrl=live' : '#';
    const dotIndex = bannerImage.lastIndexOf('.');
    const isVideo = bannerImage.substring(dotIndex) === '.mp4';

    return (
      <a className={`naked-news-live banner ${className}`} href={url}>
        {isVideo && <video className="video-player-banner" src={bannerImage} autoPlay={true} muted={true} loop={true} />}
        {!isVideo && <img alt="Naked News Live" src={bannerImage} />}
        <div className="anchor-subscribe anchor-subscribe-btn">
          {!isSubscribed && (
            <button
              className="subscribe-to-anchor-cta join-now"
              onClick={this.onClick}
            >
              SIGN UP NOW
            </button>)}
        </div>
      </a>
    );
  };

  render() {
    const {
      anchor,
      anchorVideoUrl,
      user,
      chatService,
      chatServiceTempted,
      guestUser,
      anchorId,
      openContextualOverlay,
      galleriesAndVideosCount,
      slug,
      history,
      isSpotlighing,
      spotlighedAnchorUsername,
      spotlighedAnchorNickname,
      isLivePage,
      fetchStreamDetails,
      isBanned,
      onNetworkError,
    } = this.props;
    const { isSubscribed } = this.state;
    const isWhitelisted = user?.features.includes('ANCHOR_PORTAL');
    const isAnchor = user?.user?.account.anchor;
    const anchorIsActive = anchor.active;
    const onProbation = parseInt(anchorId, 10) === 120;
    const { isInGroupShow } = GroupShowStore;
    const shouldShowInfoForGuest = (!isAnchor && !onProbation && isWhitelisted && (anchorIsActive || anchor.guest) && galleriesAndVideosCount > 0);
    const shouldShowStream = (anchorVideoUrl && isWhitelisted) || isInGroupShow;
    const canSubscribeToAnchor = !isAnchor && !onProbation && !isSubscribed && isWhitelisted && anchorIsActive && galleriesAndVideosCount > 0;

    return (
      <div className="masthead live-anchor-banner-container">
        {shouldShowStream && (
          <AnchorLiveFeed
            anchor={anchor}
            anchorId={anchorId}
            anchorVideoUrl={anchorVideoUrl}
            background={anchor.promopic}
            canSubscribeToAnchor={canSubscribeToAnchor}
            chatService={chatService}
            chatServiceTempted={chatServiceTempted}
            fetchStreamDetails={fetchStreamDetails}
            guestUser={guestUser}
            history={history}
            isAlreadySubscribedToAnchor={isSubscribed}
            isAnchor={isAnchor}
            isBanned={isBanned}
            isInGroupShow={isInGroupShow}
            isLivePage={isLivePage}
            isSpotlighing={isSpotlighing}
            isWhitelisted={isWhitelisted}
            openContextualOverlay={openContextualOverlay}
            slug={slug}
            spotlighedAnchorNickname={spotlighedAnchorNickname}
            spotlighedAnchorUsername={spotlighedAnchorUsername}
            user={user}
            onNetworkError={onNetworkError}
          />
        )}
        <div className="container">
          <div className="anchor-banner live-banner">
            {this.bannerInfoAndCta('desktop')}
          </div>
          {this.bannerInfoAndCta('mobile')}
        </div>
      </div>
    );
  }
}

export default LiveBanner;
